import { render, staticRenderFns } from "./TypeOrder.vue?vue&type=template&id=444a727d"
import script from "./TypeOrder.vue?vue&type=script&lang=js"
export * from "./TypeOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports